import { put } from 'redux-saga/effects';
import { getCookie } from '../../../utils/cookie';
import {
  APP_STORE_REVIEW_COOKIE_NAME,
  APP_STORE_REVIEW_COOKIE_COMMON_APPLICATION_VALUE,
  APP_STORE_REVIEW_CASINO_APPLICATION_SESSION_KEY,
  APP_STORE_REVIEW_CASINO_APPLICATION_SESSION_VALUE,
} from '../../../constants/appStoreReview';
import {
  setCommonAppLocalGameLaunchMode,
  setCasinoAppLocalGameLaunchMode,
} from '../../actions/app/initialization';
import Logger from '../../../services/Logger';

export const logger = new Logger('saga:localGameLaunchMode', {
  prefixColor: '#40b559',
});

export function* checkLocalGameLaunchMode() {
  const cookie = getCookie(APP_STORE_REVIEW_COOKIE_NAME) || '';
  logger.info(`${APP_STORE_REVIEW_COOKIE_NAME}: ${cookie} (${typeof cookie})`);

  const isCasinoApplicationReview = window.sessionStorage.getItem(
    APP_STORE_REVIEW_CASINO_APPLICATION_SESSION_KEY
  );
  logger.info(
    `${APP_STORE_REVIEW_CASINO_APPLICATION_SESSION_KEY}: ${isCasinoApplicationReview} (${typeof isCasinoApplicationReview})`
  );

  if (cookie === APP_STORE_REVIEW_COOKIE_COMMON_APPLICATION_VALUE) {
    yield put(setCommonAppLocalGameLaunchMode(true));
    logger.info(`Apply "Common" local game launch mode`);
  } else if (
    isCasinoApplicationReview ===
    APP_STORE_REVIEW_CASINO_APPLICATION_SESSION_VALUE
  ) {
    yield put(setCasinoAppLocalGameLaunchMode(true));
    logger.info(`Apply "Casino" local game launch mode`);
  } else {
    logger.info(`No local game launch mode is applied`);
  }
}
